<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">分账统计</span>
      </div>
    </div>
    <div class="item_box">
      <span
        class="subtitle"
        style="font-size: 14px; color: #000; margin-right: 10px"
        >收益时间:</span
      >

      <DatePicker
        type="daterange"
        v-model="date"
        placeholder="选择时间"
        @on-change="changeDate"
        style="width: 260px"
        show-week-numbers
      ></DatePicker>

      <RadioGroup
        type="button"
        style="margin-left: 10px"
        v-model="radio"
        @on-change="onChangeSelectData"
      >
        <Radio label="0">
          <span>昨&nbsp;&nbsp;日</span>
        </Radio>
        <Radio label="1">
          <span>近三天</span>
        </Radio>
        <Radio label="2">
          <span>近一周</span>
        </Radio>
      </RadioGroup>
      <!-- <Button type="primary" @click="getData()" style="margin-left: 10px"
          >筛选</Button
        > -->
      <!-- <Button type="default" @click="reset()" style="margin-left: 10px"
        >默认</Button
      > -->
    </div>
    <div class="moneyBox">
      <div class="left itemBox">
        <div class="item">
          <p class="title">总分账</p>
          <p class="val">{{ capital.total }}</p>
        </div>
        <div class="item">
          <p class="title">微信分账</p>
          <p class="val">{{ capital.wechat }}</p>
        </div>
        <div class="item">
          <p class="title">支付宝分账</p>
          <p class="val">{{ capital.ali }}</p>
        </div>
      </div>
      <div class="line"></div>
      <div class="right itemBox">
        <div class="item">
          <p class="title">总收益</p>
          <p class="val">{{ job.total }}</p>
        </div>
        <div class="item">
          <p class="title">微信收益</p>
          <p class="val">{{ job.wechat }}</p>
        </div>
        <div class="item">
          <p class="title">支付宝收益</p>
          <p class="val">{{ job.ali }}</p>
        </div>
        <div class="item">
          <p class="title">钱包收益</p>
          <p class="val">{{ job.wallet }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      job: {
        total: 0,
        wechat: 0,
        ali: 0,
        wallet: 0
      },
      capital: {
        total: 0,
        wechat: 0,
        ali: 0
      },
      date: [],
      radio: '0'
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    ...mapActions(['GetCapitalStatistic']),
    getData () {
      this.GetCapitalStatistic({ start: this.date[0], end: this.date[1] }).then(
        (res) => {
          if (!res.status) {
            this.$Message.error(res.msg)
            return false
          }
          this.job = res.data.job
          this.capital = res.data.capital
        }
      )
    },
    reset () {
      this.setTime()
      this.getData()
    },
    setTime (day = 0) {
      let now = new Date(new Date().setDate(new Date().getDate() - 1))
      now.setDate(now.getDate() - day)
      this.date = [
        this.$moment(now, 'YYYY-MM-DD'),
        this.$moment(day ? new Date(new Date().setDate(new Date().getDate() - 1)) : now, 'YYYY-MM-DD')
      ]
    },
    changeDate (e) {
      this.date = [
        this.$moment(e[0], 'YYYY-MM-DD'),
        this.$moment(e[1], 'YYYY-MM-DD')
      ]
      this.getData()
    },
    onChangeSelectData (e) {
      switch (e) {
        case '0': // 昨日
          this.setTime(0)
          this.getData()
          break
        case '1': // 3天
          this.setTime(2)
          this.getData()
          break
        case '2': // 一周
          this.setTime(6)
          this.getData()
          break
      }
    }
  }
}
</script>

<style lang="less">
.moneyBox {
  display: flex;
  border-bottom: 1px solid #e8eaec;
  border-top: 1px solid #e8eaec;
  margin-top: 10px;
  padding-bottom: 20px;
  padding-top: 20px;
  .itemBox {
    flex: 1;
    display: flex;
    height: 100%;
    .item {
      flex: 1;
      text-align: center;
      height: 100%;

      .title {
        font-size: 14px;
      }
      .val {
        font-size: 18px;
        color: #222;
      }
    }
  }
  .left {
    .item {
      &:nth-child(1) {
        .title {
          color: rgb(216, 20, 20);
        }
      }
    }
  }
  .right {
    .item {
      &:nth-child(1) {
        .title {
          color: rgb(13, 162, 32);
        }
      }
    }
  }
  .line {
    width: 1px;
    background: #e8eaec;
  }
}
</style>
